// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___e6ms0","paging":"styles__paging___3GdgB","hide-on-desktop":"styles__hide-on-desktop___1zwbH"};